import { defineComponent as _defineComponent } from 'vue'
import { inject, Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IWithdrawConclusion } from '@/modules/transaction/services/product-withdraw';


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawCompletedStep',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const withdrawConclusion = inject(
  'withdrawConclusion'
) as Ref<IWithdrawConclusion>;

function goToProducts() {
  router.push({
    name: 'productsCatalog',
    params: {
      type: route.params.type || 'fixed-income'
    }
  });
}

return { __sfc: true,route, router, withdrawConclusion, goToProducts, ConclusionStep, ContentDisplay, Heading, ListDisplay, ButtonPrimary }
}

})